export default __webpack_public_path__ + "static/media/horns.cfffa59e.svg";